<template>
  <div>
    <law-statute :clcki-name="clckiName" />
  </div>
</template>

<script>
// 获取接口地址
import LawStatute from '../components/xxhd/flfg/lawStatute.vue'

export default {
  name: 'Flfg',
  components: {
    LawStatute
    // sideMenu,
    // Header
  },
  data() {
    return {
      clckiName: '详情'
    }
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
